import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {withTranslation} from 'react-i18next';

import styles from './style.css';
import {setFormat} from '../../../store/create-llama/actions';
import {
    createLlamaFormatSelector,
    createLlamaTypeSelector, createStickerIdSelector, createStickerItemIdSelector
} from '../../../store/create-llama/selectors';
import {StickerFormatEnum} from '../../../domain/enums/StickerFormatEnum';
import ModeratorCog from '../../components/moderator-cog';

import StickersComponentsScannerHeader from "../../components/scanner-header";
import {createClassNames} from '../../../../../infrastructure/helpers';
import {setOriginPhoto} from '../../../store/media-photo/actions';
import {onVideoSelected} from '../../../store/media-video/actions';
import Div100vh from '../../../../uq-ui/components/div-100';
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import {isMediaStreamFailed} from '../../../store/media-video/selectors';
import Button from '@material-ui/core/Button';
import {TinySliderInstance, tns} from 'tiny-slider/src/tiny-slider'
import i18n, {withTypeTranslation} from "../../../../../i18n";
import {isMediaStreamAvailable} from './helpers';
import {isCurrentUserLoggedSelector, moderatorModeSelector} from "../../../../auth/store/auth-user/selectors";
import { setAudioDuration, setOriginAudio } from '../../../store/media-audio/actions';
import { addStickerItem } from '../../../store/sticker-show/actions';
import cacheManager from '../../../domain/services/StickerCache';
import FormatIcon from '../../components/format-icon';

// Its a fake data
const formatsData = [
    {
        format: StickerFormatEnum.Video,
        icon: {
            name: 'FormatVideoOutline',
            nameGray: 'FormatVideoOutlineGray',
            nameDark: 'FormatVideoOutlineDark',
            w: 80,
            h: 80
        },
        label: 'videoLabel',
        descTitle: 'videoTitle',
        descSubtitle: 'videoSubtitle'
    },
    {
        format: StickerFormatEnum.Audio,
        icon: {
            name: 'FormatAudioOutline',
            nameGray: 'FormatAudioOutlineGray',
            nameDark: 'FormatAudioOutlineDark',
            w: 80,
            h: 80
        },
        label: 'audioLabel',
        descTitle: 'audioTitle',
        descSubtitle: 'audioSubtitle'
    },
    {
        format: StickerFormatEnum.Image,
        icon: {
            name: 'FormatImageOutline',
            nameGray: 'FormatImageOutlineGray',
            nameDark: 'FormatImageOutlineDark',
            w: 80,
            h: 80
        },
        label: 'imageLabel',
        descTitle: 'imageTitle',
        descSubtitle: 'imageSubtitle'
    },
    {
        format: StickerFormatEnum.Upload,
        icon: {
            name: 'FormatUploadOutline',
            nameGray: 'FormatUploadOutlineGray',
            nameDark: 'FormatUploadOutlineDark',
            w: 80,
            h: 80
        },
        label: 'uploadLabel',
        descTitle: 'uploadTitle',
        descSubtitle: 'uploadSubtitle'
    }
];

function getFormatDataByFormat(format, formatDataList) {
    if (format) {
        return formatDataList.find((f) => f.format === format);
    }

    return null;
}


interface IHistoryProps {
    history: any
}

interface II18nProps {
    t: any
    t2: any
}


interface IShowStickerItemProps {
    stickerId: any;
    stickerItemId: any;
    selectedFormat: any;
    isMediaStreamFailed: boolean;
    stickerType: any;
    isLogged: boolean;
    isCongratulationView: boolean;
    canModerate: boolean;
}

interface IShowStickerDispatchProps {
    setFormat: (format) => Promise<void>;
    setOriginPhoto: (photoInfo) => Promise<void>;
    onVideoSelected: (file) => Promise<void>;
    setOriginAudioOnSelected: (file) => Promise<void>;
    setAudioDurationOnSelected: (file) => Promise<void>;
    addStickerItem: (stickerId) => Promise<void>;
}

type IProps = IShowStickerItemProps & IHistoryProps & IShowStickerDispatchProps & II18nProps


class StickersScreensNewStickerFormat extends PureComponent<IProps> {
    slider: TinySliderInstance;
    state: {
        selectedFormatItem: any;
        isMediaStreamAvailable: boolean
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const hasSelectedFormat = nextProps.selectedFormat != null && nextProps.selectedFormat !== '';
        const isComponentFormatEmpty = prevState.selectedFormatItem == null;

        if (hasSelectedFormat && isComponentFormatEmpty ||
            hasSelectedFormat && !isComponentFormatEmpty &&
            nextProps.selectedFormat !== prevState.selectedFormatItem.format) {
            const selectedFormatItem = getFormatDataByFormat(nextProps.selectedFormat, formatsData);
            return {selectedFormatItem};
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedFormatItem: getFormatDataByFormat(props.selectedFormat, formatsData),
            isMediaStreamAvailable: isMediaStreamAvailable()
        };
    }

    componentDidMount() {
        goolgeAnalytics.setCurrentScreen('web-new-sticker-format');
        this.slider = tns({
            container: '.sticker-format-slider',
            slideBy: 'page',
            nav: false,
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout: 2000,
            controls: false,
            autoplayButtonOutput: false
        });
    }

    isWebRtcAvailable() {
        return this.state.isMediaStreamAvailable && !this.props.isMediaStreamFailed;
    }

    onFormatSelect = (format) => {
        this.props.setFormat(format);
    };

    onBackPressed = () => {
        this.props.history.go(-2);
    };

    getObjectUrl(event) {
        const file = event.target.files[0];
        const urlCreator = window.URL || window.webkitURL;
        return urlCreator.createObjectURL(file);
    }

    onImageInputChange = async (event) => {
        const imageUrl = this.getObjectUrl(event);
        const blob = event.target.files[0];
        this.props.setOriginPhoto({uri: imageUrl, blob});

        if (this.props.isCongratulationView) {
            cacheManager.removeCachedSticker(this.props.stickerId);
            await this.props.addStickerItem(this.props.stickerId)
        }

        this.props.history.push(`/stickers/${this.props.stickerId}/new/photo`);
    };

    onVideoInputChange = async (event) => {
        const file = event.target.files[0];
        this.props.onVideoSelected(file);

        if (this.props.isCongratulationView) {
            cacheManager.removeCachedSticker(this.props.stickerId);
            await this.props.addStickerItem(this.props.stickerId)
        }

        this.props.history.push(`/stickers/${this.props.stickerId}/new/video`);
    };

    onAudioInputChange = async (event) => {
        if (!event.target.files.length) {
            return;
        }

        const file = event.target.files[0];

        if (this.props.isCongratulationView) {
            cacheManager.removeCachedSticker(this.props.stickerId);
            await this.props.addStickerItem(this.props.stickerId)
        }
      
        const urlCreator = window.URL || window.webkitURL;
        const uri = urlCreator.createObjectURL(file);
      
        const reader = new FileReader();
      
        reader.onload = () => {
            const audioFile = new Audio(reader.result as any);
            audioFile.onloadedmetadata = () => {
              file.arrayBuffer().then(async (arrayBuffer) => {
                const blob = new Blob([new Uint8Array(arrayBuffer)], { type: file.type });
                await this.props.setOriginAudioOnSelected({ blob, uri });
                await this.props.setAudioDurationOnSelected(audioFile.duration);
                this.onAudioNextPressed();
              });
            };
        };
      
        reader.onerror = () => {
            console.error(reader.error);
            new Noty({
              type: 'error',
              timeout: 4000,
              text: this.props.t('errors.browserSupport'),
            }).show();
        };
      
        reader.readAsDataURL(file);
    };

    onUploadInputChange = async (event) => {
        const file = event.target.files[0];
        const isVideo = file.type.indexOf('video') !== -1;
        const isImage = file.type.indexOf('image') !== -1;
        const isAudio = file.type.indexOf('audio') !== -1;
        if (isVideo) {
            this.onVideoInputChange(event);
            this.props.setFormat(StickerFormatEnum.Video);
        } else if (isImage) {
            this.props.setFormat(StickerFormatEnum.Image);
            this.onImageInputChange(event);
        } else if (isAudio) {
            this.props.setFormat(StickerFormatEnum.Audio);
            this.onAudioInputChange(event);
        }
    };

    onAudioNextPressed = () => {
        this.props.history.push(`/stickers/${this.props.stickerId}/new/audio`);
    };

    onRecordVideoByStreamPressed = () => {
        this.props.history.push(`/stickers/${this.props.stickerId}/new/video-record`);
    };


    _onFormatClicked(format) {
        if (!this.props.isLogged) {
            this.props.history.push(`/login`);
            localStorage.setItem('stickerForContinue', this.props.stickerId);
            return;
        }
        this.onFormatSelect(format);
        switch (format) {
            case StickerFormatEnum.Video:
                if (this.isWebRtcAvailable()) {
                    this.onRecordVideoByStreamPressed();
                }
                break;
            case StickerFormatEnum.Audio:
                this.onAudioNextPressed();
                break;
            default:
                break;
        }
    }

    _renderFormat(formatData) {
        const {format, label} = formatData;
        const formatWrap = screen.height < 550 ? {margin: '3px'} : {};
        const formatWrapClass = createClassNames([styles.formatWrap]);

        return (
            <div className={styles.buttonWrapper} key={label}>
                <Button component="label" key={format} onClick={() => this._onFormatClicked(format)} className={formatWrapClass} style={formatWrap}>
                    {this._renderInput(format)}
                    <div className={styles.formatIconWrap}>
                        <FormatIcon format={format} size={44}/>
                        <div className={styles.formatTitle}>{this.props.t(label)}</div>
                    </div>
                </Button>
            </div>
        );
    }

    _renderInput(format) {
        if (!this.props.isLogged) {
            return;
        }

        switch (format) {
            case StickerFormatEnum.Video:
                if (!this.isWebRtcAvailable()) {
                    return (<input type="file"
                                   accept="video/*"
                                   onChange={this.onVideoInputChange}
                                   capture
                                   className={styles.submitInput}/>);
                }
                return null;
            case StickerFormatEnum.Image:
                return (<input type="file"
                               accept="image/*"
                               onChange={this.onImageInputChange}
                               capture
                               className={styles.submitInput}/>);
            case StickerFormatEnum.Upload:
                return (<input type="file"
                               onChange={this.onUploadInputChange}
                               className={styles.submitInput}/>);
            default:
                return null;
        }
    }

    render() {
        return (
            <Fragment>
                {/*
                 // @ts-ignore */}
                <StickersComponentsScannerHeader theme="brand"
                                                 title={this.props.t('headerTitle')}
                                                 showBackBtn={!this.props.isCongratulationView}
                                                 onBack={this.onBackPressed}
                />
                <Div100vh className={ `${styles.scrollView} ${this.props.isCongratulationView ? styles.isCongratulationView : ''}` } style={{minHeight: '100rvh'}}>
                    <div dir="ltr" style={{
                        position: 'relative',
                        zIndex: 2,
                        flex: 1,
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div className={styles.header}>
                            <div className={`${styles.title} font-title`}
                                 dangerouslySetInnerHTML={{__html: this.props.t2(this.props.stickerType === 'MEMORIAL' ? "MEMORIAL" : "default", 'title')}}/>
                        </div>

                        <div className={styles.formats}>
                            {formatsData.map((formatData, index) => this._renderFormat(formatData))}
                        </div>

                        <div className={`${styles.description}`}>
                            <div className={`sticker-format-slider`}>
                                {formatsData.map((formatData, index) => (
                                    <div dir={i18n.dir()} key={index}>
                                        <div className={styles.activeFormatIcon}>
                                            <FormatIcon format={formatData.format} size={36}/>
                                        </div>
                                        <div className={styles.activeFormatLabelsWrap}>
                                            <div className={styles.activeFormatTitle}>
                                                {formatData && this.props.t2(this.props.stickerType, formatData.descTitle)}
                                            </div>
                                            <div className={styles.activeFormatDesc}
                                                 dangerouslySetInnerHTML={{__html: formatData && this.props.t2(this.props.stickerType, formatData.descSubtitle)}}/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Div100vh>
                {/* Moderator mode: reset / switch type before setting the sticker up.
                    Afterwards the flow restarts with the sticker's new state. */}
                {this.props.canModerate && !this.props.isCongratulationView && this.props.stickerId && (
                    <ModeratorCog stickerId={this.props.stickerId}
                                  type={this.props.stickerType}
                                  onDone={() => window.location.reload()}/>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        stickerId: createStickerIdSelector(state),
        stickerItemId: createStickerItemIdSelector(state),
        selectedFormat: createLlamaFormatSelector(state),
        isMediaStreamFailed: isMediaStreamFailed(state),
        stickerType: createLlamaTypeSelector(state),
        isLogged: isCurrentUserLoggedSelector(state),
        canModerate: moderatorModeSelector(state),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFormat: (format) => dispatch(setFormat(format)),
        setOriginPhoto: (photoInfo) => dispatch(setOriginPhoto(photoInfo)),
        onVideoSelected: (file) => dispatch(onVideoSelected(file)),
        setOriginAudioOnSelected: (file) => dispatch(setOriginAudio(file)),
        setAudioDurationOnSelected: (file) => dispatch(setAudioDuration(file)),
        addStickerItem: (stickerId) => dispatch(addStickerItem(stickerId)),
    }
};

export default compose(
    withTranslation('scr-new-sticker-format'),
    connect(mapStateToProps, mapDispatchToProps),
    withTypeTranslation,
)(StickersScreensNewStickerFormat);
